import React from "react";
import { PatchedOnlineBrand, SupportedOnlineBrand } from "checkout/ts/redux/utils/online-constants";
import { getStepUrl, StepName } from "checkout/ts/utils/StepName";
import { OnlineBrand, PaymentType } from "univapay-node";

import { AlipayOnlineIcon } from "../../icons/AlipayOnlineIcon";
import { DBaraiOnlineIcon } from "../../icons/DBaraiOnlineIcon";
import { PayPayOnlineIcon } from "../../icons/PayPayOnlineIcon";
import { WeChatOnlineDarkIcon } from "../../icons/WeChatOnlineDarkIcon";
import { WeChatOnlineIcon } from "../../icons/WeChatOnlineIcon";

export const getOnlineRoutes = (stepName: StepName, paymentMethodKey: string) =>
    ({
        [StepName.GATEWAY]: getStepUrl(PaymentType.ONLINE, paymentMethodKey, StepName.GATEWAY),
        [StepName.PROCESSING]: getStepUrl(PaymentType.ONLINE, paymentMethodKey, StepName.PROCESSING),
        [StepName.ADDRESS]: getStepUrl(PaymentType.ONLINE, paymentMethodKey, StepName.ADDRESS),
        [StepName.DATA]: getStepUrl(PaymentType.ONLINE, paymentMethodKey, StepName.DATA),
        [StepName.CONFIRM]: getStepUrl(PaymentType.ONLINE, paymentMethodKey, StepName.CONFIRM),
    }[stepName]);

export const getOnlineBrandIcon = (paymentType: SupportedOnlineBrand, dark?: boolean) => {
    switch (paymentType) {
        case OnlineBrand.ALIPAY_ONLINE:
            return <AlipayOnlineIcon />;

        case PatchedOnlineBrand.D_BARAI_ONLINE:
            return <DBaraiOnlineIcon />;

        case OnlineBrand.PAY_PAY_ONLINE:
            return <PayPayOnlineIcon />;

        case OnlineBrand.WE_CHAT_ONLINE:
            return dark ? <WeChatOnlineDarkIcon /> : <WeChatOnlineIcon />;

        case OnlineBrand.ALIPAY_PLUS_ONLINE:
            return null;
    }
};
